<template>
  <div class="page-max-width footer-max-width">
    <QHeader class="bg-primary text-white">
      <QToolbar>
        <QBtn
          flat
          round
          dense
          icon="icon-f-arrow-left"
          @click="onGoBack"
        />
        <QToolbarTitle>
          {{ $t('ETAB.PAGES.CONFIDENTIALITY.@TITLE') }}
        </QToolbarTitle>
      </QToolbar>
    </QHeader>

    <QPageContainer>
      <QPage padding>
        <Confidentiality />
      </QPage>
    </QPageContainer>

    <QFooter class="bg-transparent footer-padding">
      <div>
        <QBtn
          color="secondary"
          class="full-width btn-navigation semi-transparent-bottom-shadow"
          :label="$t('ETAB.PAGES.CONFIDENTIALITY.@BACK')"
          no-caps
          @click="onGoBack"
        />
      </div>
    </QFooter>
  </div>
</template>

<script>
import { StatusBar } from "@core/plugins/mobile";
import { ETAB_ROUTES } from "@etab/config";

import Confidentiality from "@core/components/legal/Confidentiality.component.vue";

export default {
  components: {
    Confidentiality,
  },
  created() {
    StatusBar.setPrimaryBackground();
  },
  beforeUnmount() {
    StatusBar.setDefault();
  },
  methods: {
    onGoBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push({ name: ETAB_ROUTES.userMenu.root.name }).catch(suppressedError => {});
      }
    },
  },
};
</script>
